module.exports = __webpack_public_path__ + "img/Triangle_Down.ed8a2a34.svg";